import { exists, translate } from "application/functions";
import { endsWith, filter, includes, isEmpty, keys, length, startsWith, map, split } from "ramda";

export default function validateGarments(value, deletedProducts) {
  const errors = { messages: [], keys: [] };

  const deletedGarmentKeys = map((p) => `garment[${p}]`, deletedProducts);
  const garmentKeys = filter((k) => {
    if (!startsWith("garment", k)) {
      return false;
    }
    const initialKey = split(".", k)[0];

    return !includes(initialKey, deletedGarmentKeys);
  }, keys(value));

  if (isEmpty(garmentKeys)) {
    errors.keys = [...errors.keys, ...["no answer"]];
  }

  const unanswered = filter((k) => !exists(value[k]) && !endsWith("arrangement_images.value", k), garmentKeys);

  const unansweredImg = filter((k) => !exists(value[k]) && endsWith("[0].arrangement_images.value", k), garmentKeys);

  if (length(unansweredImg) > 0) {
    errors.messages = [...errors.messages, translate("error.image")];
    errors.keys = [...errors.keys, ...unansweredImg];
  }

  if (exists(unanswered)) {
    errors.keys = [...errors.keys, ...unanswered];
  }

  const garmentErrors = checkGarment(garmentKeys);

  if (exists(garmentErrors?.keys)) {
    errors.messages = [...errors.messages, ...garmentErrors.messages];
    errors.keys = [...errors.keys, ...garmentErrors.keys];
  }

  if (exists(errors.keys)) {
    errors.messages = errors.messages.reduce((acc, m) => {
      return includes(m, acc) ? acc : [...acc, m];
    }, []);
    return errors;
  }
  return null;
}

const checkGarment = (value) => {
  const errors = { messages: [], keys: [] };
  const aKeys = keys(value);
  const garmentKeys = filter((k) => startsWith("garment", k), aKeys);

  if (!exists(garmentKeys)) {
    return errors;
  }
};
